import { render } from "./SiteCarousel.vue?vue&type=template&id=b846ce00&scoped=true"
import script from "./SiteCarousel.vue?vue&type=script&lang=js"
export * from "./SiteCarousel.vue?vue&type=script&lang=js"

import "./SiteCarousel.vue?vue&type=style&index=0&id=b846ce00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b846ce00"]])

export default __exports__